<template>
  <DataTable ref="dataTable" :columns="taskColumnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="6" :url="dataURL" :filterOptions="taskFilterOptions" :displayTools="true" :hasDateRangeFilter="true" :displayLocationFilter="true" :useQueryData="useQueryData" :displayExportTools="true" exportTitle="Tasks">
    <template v-slot:title>
      <slot name="title" />
    </template>
    <template v-slot:tools>
      <slot name="tools" />
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <LinkTask :name="row.data.sequenceNumber ? '#'+row.data.sequenceNumber : 'Pending'" :id="row.data.id" :newTab="openNewTab" />
        </td>
        <td>
          {{row.data.name}}
        </td>
        <td>
          {{row.data.description | formatHyphenEmptyValue}}
        </td>
        <td>
          <LabelBadge :labelColour="row.data.taskType.highlightColour">{{row.data.taskType.name}}</LabelBadge>
        </td>
        <td>
          <LabelBadge :labelClass="`label-task-status-${row.data.status}`">{{row.data.status | formatLookupName(TaskStatusTypeLookup)}}</LabelBadge>
        </td>
        <td>
          <LabelTags :labelList="row.data.labelList" />
        </td>
        <td>{{row.data.createdAt | formatDateTime}}</td>
        <td>{{row.data.scheduleEndDate | formatDateTime}}</td>
        <td>{{row.data.closedDate | formatDateTime}}</td>
        <td>
          <LabelAccountLocationBadge :accountLocation="row.data.accountLocation" />
        </td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import _ from 'lodash'
import { mapState } from "vuex"

import Utils from '@/utils/utils'

import { TaskStatusTypes, TaskStatusTypeLookup } from '@/store/types'

export default {
  name: "TaskDataTable",
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    taskTypeIdFilter: Number,
    useQueryData: Boolean
  },
  created() {
    this.TaskStatusTypeLookup = TaskStatusTypeLookup
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.$refs.dataTable.resetTableInfo()
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }

      if(this.taskTypeIdFilter)
        params.filter.taskTypeId = this.taskTypeIdFilter

      return '/tasks?' + $.param(params)
    },
    taskColumnList() {
      return _.compact([
        { title: "Number", data: "sequenceNumber" },
        { title: "Name", data: "name" },
        { title: "Details", data: "description" },
        { title: "Type", data: "taskType.name" },
        { title: "Status", data: "status" },
        { title: "Labels", data: "labelListNames", type: 'label' },
        { title: "Created", data: "createdAt", dateFilter: true, type: 'datetime' },
        { title: "Scheduled End Date", data: "scheduleEndDate", dateFilter: true, type: 'datetime' },
        { title: "Completed Date", data: "closedDate", dateFilter: true, type: 'datetime' },
        { title: "Location", data: "accountLocation.name" }
      ])
    },
    taskFilterOptions() {
      let filterOptions = []
      
      filterOptions.push({
        field: 'status',
        name: 'Status',
        columnIndex: 0,
        options: [
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.pendingProduction), value: TaskStatusTypes.pendingProduction, class: 'label-task-status-pendingProduction' },
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.pendingApproval), value: TaskStatusTypes.pendingApproval, class: 'label-task-status-pendingApproval' },
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.loading), value: TaskStatusTypes.loading, class: 'label-task-status-loading' },
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.ready), value: TaskStatusTypes.ready, class: 'label-task-status-ready' },
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.inProgress), value: TaskStatusTypes.inProgress, class: 'label-task-status-inProgress' },
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.completed), value: TaskStatusTypes.completed, class: 'label-task-status-completed' },
          { name: Utils.getLookupName(TaskStatusTypeLookup, TaskStatusTypes.cancelled), value: TaskStatusTypes.cancelled, class: 'label-task-status-cancelled' }
        ]
      })

      let taskLabels = this.$store.getters['label/getLabelsByType']('task')
      filterOptions.push({
        name: 'Task Label',
        field: 'labelListNames',
        operator: 'like',
        columnIndex: 1,
        options: _.cloneDeep(taskLabels).reverse().map(labelInfo => {
            return {
              name: labelInfo.name,
              value: '%' + labelInfo.name + '%',
              colour: labelInfo.colour
            }
        })
      })
      
      return filterOptions
    }
  },
  data() {
    return {
      taskTypeList: [],
      breadcrumbs: [
        { title: 'Task', link: '/tasks'}
      ]
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.$apiService.tasksService.getTaskTypeList()
      .then(response => {
        this.taskTypeList = response.data
      })
      .catch(err => {
        console.error(err)
      })
    },
    reload() {
      this.$refs.dataTable.reload()
    },
    removeSelectedFilters(filters) {
      this.$refs.dataTable.removeSelectedFilters(filters)
    },
    applySelectedFilters(filters) {
      this.$refs.dataTable.applySelectedFilters(filters)
    },
    addSelectedFilters(filters) {
      this.$refs.dataTable.addSelectedFilters(filters)
    }
  }
};
</script>
